import React from 'react'
import Projects from './Projects'
function Allprojects() {
  return (
    <div className=' justify-center  bg-gray-800 '>
      <Projects/>
    </div>
  )
}

export default Allprojects
